import renderTable from './render-table';
import getData from './get-data';

const allAssets = {};
let filterType = 'all'
let sortType = ''
let itemsToLoad = 24 //array index
let itemsToAdd = 25

if (window.innerWidth < 1200) {
    itemsToLoad = 7
    itemsToAdd = 8
}

const start = async () => {
    //rendering filter data
    const allEl = document.querySelector('[data-filter-type="all"] span')
    const coinsEl = document.querySelector('[data-filter-type="coins"] span')
    const ercEl = document.querySelector('[data-filter-type="erc"] span')
    const bepEl = document.querySelector('[data-filter-type="bnb"] span')
    const trxEl = document.querySelector('[data-filter-type="trx"] span')

    //getting coin tag lists
    const all = await (await fetch('/api/get-valid-coins?type=all')).json()
    const coins = await (await fetch('/api/get-valid-coins?type=coin')).json()
    const erc = await (await fetch('/api/get-valid-coins?type=ethereum')).json()
    const trx = await (await fetch('/api/get-valid-coins?type=tron20')).json()
    const bnb = await (await fetch('/api/get-valid-coins?type=bnb smart chain (bep20)')).json()

    const filterArrs = {
        all,
        coins,
        erc,
        trx,
        bnb
    }

    coinsEl.innerHTML = coins.length
    allEl.innerHTML = all.length
    ercEl.innerHTML = erc.length
    bepEl.innerHTML = bnb.length
    trxEl.innerHTML = trx.length
    //

    //first render
    const firstPage = all.slice(0, itemsToLoad)
    await renderTable(allAssets, firstPage)
    
    //filters
    const filterBtns = document.querySelectorAll('[data-filter-type]')
    filterBtns.forEach(function(item) {
        item.addEventListener('click', async function() {
            filterType = this.getAttribute('data-filter-type')

            //changing styles
            filterBtns.forEach(item => item.classList.remove('active'))
            this.classList.add('active')

            itemsToLoad = itemsToAdd
            await renderTable(allAssets, filterArrs[filterType].slice(0, itemsToLoad))
            checkLoadButton()

            const searchEl = document.querySelector('.assets__search')
            searchEl.value = ''
            sortType = ''
        })
    })
    
    //load-more
    const loadBtn = document.querySelector('.assets__load-more')
    loadBtn.addEventListener('click', () => {
        itemsToLoad += itemsToAdd
        renderTable(allAssets, filterArrs[filterType].slice(0, itemsToLoad))
        checkLoadButton()

        const search = document.querySelector('.assets__search')
        search.value = ''
    })
    function checkLoadButton() {
        if (filterArrs[filterType].length > itemsToLoad) {
            loadBtn.classList.remove('disabled')
        } else {
            loadBtn.classList.add('disabled')
        }
    }

    //sort
    const filterEls = document.querySelectorAll('[data-sort-type]')
    filterEls.forEach(item => item.addEventListener('click', async function() {
        await getData(allAssets, filterArrs[filterType])

        const search = document.querySelector('.assets__search')
        search.value = ''

        filterArrs[filterType] = filterArrs[filterType].filter(key => {
            const {
                price,
                change24,
                fullName
            } = allAssets[key]

            if (!allAssets[key] || price === 'undefined' || !change24 || !fullName) return false

            return true
        })

        //reverse sorting
        const newSortType = this.getAttribute('data-sort-type')
        if (sortType === newSortType) return await renderTable(allAssets, filterArrs[filterType].reverse().slice(0, itemsToLoad))
        //

        sortType = newSortType

        const sort = {
            asset() {
                filterArrs[filterType].sort((a, b) => {
                    const nameA = allAssets[a]?.fullName.toUpperCase()
                    const nameB = allAssets[b]?.fullName.toUpperCase()

                    if (nameA < nameB) return -1
                })
            },
            price() {
                filterArrs[filterType].sort((a, b) => {
                    const nameA = allAssets[a]?.price
                    const nameB = allAssets[b]?.price

                    if (nameA > nameB) return -1
                })
            },
        }

        sort[sortType]()
        await renderTable(allAssets, filterArrs[filterType].slice(0, itemsToLoad))
        checkLoadButton()
    }))

    //search
    const searchEl = document.querySelector('.assets__search')
    searchEl.addEventListener('input', async function() {
        await getData(allAssets, filterArrs[filterType])

        const val = this.value.toUpperCase()
        const filtered = filterArrs[filterType].filter(short => {
            const full = allAssets[short].fullName || ''

            return full.toUpperCase().includes(val) || short.toUpperCase().includes(val)
        })
                
        if (val) {
            await renderTable(allAssets, filtered)
            loadBtn.classList.add('disabled')
        } else {
            await renderTable(allAssets, filtered.slice(0, itemsToLoad))
            loadBtn.classList.remove('disabled')
        }
    })
}
start()